import axios from 'axios';
import {
	req,
	reqF,
} from './axiosFun';


// 获取支付记录分页列表
export const GetPayHistoryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Pay/GetPayHistoryPageList", params)
};
// 支付记录查询
export const GetPayHistoryList = (params) => {
	return reqF("post", "/api/sysConfig/Pay/GetPayHistoryList", params)
};
// 支付记录月统计
export const GetPayHistoryMonthStatistic = (params) => {
	return reqF("post", "/api/sysConfig/Pay/GetPayHistoryMonthStatistic", params)
};
// 导出收款记录
export const ExportPayHistory = (params) => {
	return reqF("post", "/api/sysConfig/Pay/ExportPayHistory", params)
};


// 获取问题支付记录分页列表
export const GetProblemPayRecordPageList = (params) => {
	return reqF("post", "/api/sysConfig/Pay/GetProblemPayRecordPageList", params)
};
// 处理问题支付记录
export const HnadleProblemPayRecord = (params) => {
	return reqF("post", "/api/sysConfig/Pay/HnadleProblemPayRecord", params)
};